var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_vm._m(0),_c('router-view',{staticClass:"mark"})],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"smallwidth"},[_c('div',{staticClass:"bg"},[_c('div',{staticClass:"tip"},[_c('p',[_vm._v("该项目暂未适应小屏设备")]),_c('p',[_vm._v("为了您的良好浏览体验")]),_c('p',[_vm._v("您可以使用更大的屏幕或者设备")]),_c('p',[_vm._v("感谢理解关注😉")]),_c('p',[_vm._v("Thanks❤️")])])])])
}]

export { render, staticRenderFns }